import { IEntity } from '@pf/shared-common';
import {
    ContainerFragment,
    Currency,
    InventoryBundleInstanceFragment,
    InventoryBundleReservation,
    InventoryBundleSearchRequestParams,
    InventoryBundleStatus,
    InventoryBundleViewModelCreateBody,
    InventoryBundleViewModelRead,
    ItemFragment,
    ResourceAuth,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import {
    CustomFieldDto,
    ICustomerFragmentDto,
    IVendorFragmentDto,
} from '@pf/shared/util-platform';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';

export type InventoryBundleRead = InventoryBundleViewModelRead & IEntity;
export type InventoryBundleCreate = InventoryBundleViewModelCreateBody;
export type InventoryBundleSearchParams = InventoryBundleSearchRequestParams;

export class InventoryBundleDto implements IWarehouseEntity {
    constructor(data: Partial<InventoryBundleDto>) {
        Object.assign(this, data);
    }

    get name() {
        return `${this.item?.name} - ${this.availableQuantity} available | ${this.reservedQuantity} reserved`;
    }

    id!: string;
    warehouse!: WarehouseFragment;

    condition?: string | null;
    inventoryBundleReservations?: Array<InventoryBundleReservation> | null;
    totalQuantity?: number;
    averageUnitCost?: Currency;
    status?: InventoryBundleStatus;
    item?: ItemFragment;
    container?: ContainerFragment;
    customer?: ICustomerFragmentDto;
    vendor?: IVendorFragmentDto;
    readonly reservedQuantity?: number;
    readonly availableQuantity?: number;
    inventoryBundleInstances?: Array<InventoryBundleInstanceFragment> | null;
    customFields?: CustomFieldDto[];
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
    resourceAuth?: ResourceAuth;
}
